export class Collect {

    public id: string = "0";    
    public date : Date;
    public status: string = '0';
    public member_id: string;
    public member_name: string;
    public member_email: string;
    public member_cpf: string;
    public qtd: number;
    public value: number;
    public collect: any[];
    public pix: any = {};
    public capture: any = {};
    public link: string;
    public isAnnuity: boolean;
    public archived: boolean;

    constructor() {}
    
} 